<template>
  <div>
    <!-- Button trigger modal -->
    <div type="button" class="settings-item" data-bs-toggle="modal" data-bs-target="#changeThemeColorModal">
      
      <!-- <div class="settings-item"> -->
        <div class="settings-icon">
          <i class="bi bi-palette"></i>
        </div>
        <div class="settings-content">
          <h5>Change Theme</h5>
          <p>Switch between light and dark mode</p>
        </div>
        </div>
    <!-- </button> -->

    <!-- Modal -->
    <div class="modal fade" id="changeThemeColorModal" tabindex="-1" aria-labelledby="changeThemeColorModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="changeThemeColorModalLabel">🎨 Theme Settings</h5>
            <span class="badge bg-light text-dark">{{ modeLabel }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <p class="text-muted mb-3">Click a theme to apply it:</p>
            <div class="d-flex flex-wrap justify-content-center">
              <label
                v-for="mode in modes"
                :key="mode.value"
                class="btn m-1"
                :class="[currentMode === mode.value ? mode.activeClass : mode.defaultClass]"
              >
                <input
                  type="radio"
                  name="theme"
                  :value="mode.value"
                  v-model="currentMode"
                  @change="onThemeChange"
                  autocomplete="off"
                />
                {{ mode.label }}
              </label>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      currentMode: localStorage.getItem("themeMode") || "light-mode",
      userId: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      modes: [
        { label: "Light", value: "light-mode", defaultClass: "btn-outline-secondary", activeClass: "btn-secondary text-white" },
        { label: "Dark", value: "dark-mode", defaultClass: "btn-outline-dark", activeClass: "btn-dark text-white" },
        { label: "Light Gold", value: "custom-mode", defaultClass: "btn-outline-warning", activeClass: "btn-warning text-dark" },
        { label: "Blue", value: "blue-mode", defaultClass: "btn-outline-primary", activeClass: "btn-primary text-white" },
        { label: "Green", value: "green-mode", defaultClass: "btn-outline-success", activeClass: "btn-success text-white" },
        { label: "Pink", value: "pink-mode", defaultClass: "btn-outline-pink", activeClass: "btn-pink text-white" }
      ]
    };
  },
  computed: {
    modeLabel() {
      return this.currentMode.replace("-mode", "").toUpperCase();
    }
  },
  async mounted() {
    await this.fetchThemeFromDatabase();
    this.applyModeClass(this.currentMode);
  },
  methods: {
    async onThemeChange() {
      localStorage.setItem("themeMode", this.currentMode);
      this.applyModeClass(this.currentMode);
      await this.saveThemeToDatabase();
    },
    applyModeClass(mode) {
      const allModes = this.modes.map(m => m.value);
      document.body.classList.remove(...allModes);
      document.body.classList.add(mode);
    },
    async fetchThemeFromDatabase() {
      try {
        const response = await axios.get(`/getThemeColorSettings/${this.userId}`, {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        if (response.data?.theme_color) {
          this.currentMode = response.data.theme_color;
          localStorage.setItem("themeMode", this.currentMode);
        }
      } catch (error) {
        console.error("Failed to fetch theme:", error);
      }
    },
    async saveThemeToDatabase() {
      try {
        await axios.post("/saveThemeColorSettings", {
          user_id: this.userId,
          theme_color: this.currentMode
        }, {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        console.log("Theme saved to DB");
      } catch (error) {
        console.error("Failed to save theme:", error);
      }
    }
  }
};
</script>

<style scoped>

@import "@/assets/styles/settings.scss";


.btn-pink {
  background-color: #e83e8c;
  border-color: #e83e8c;
}
.btn-outline-pink {
  color: #e83e8c;
  border-color: #e83e8c;
}
.btn-outline-pink:hover {
  background-color: #e83e8c;
  color: #fff;
}
</style>
